import React from 'react';
import { motion } from 'framer-motion';
import { Book, Zap, Shield, Coffee, Brain, Layout, Gift, ArrowRight } from 'lucide-react';
import { scrollToCheckout } from '../utils/scroll';
const tomos = [{
  icon: <Brain className="text-gold-500" size={28} data-id="element-231" />,
  title: 'TOMO 1: Biología del Caos',
  subtitle: 'Por qué tu cabeza no para — y por qué no es tu culpa'
}, {
  icon: <Zap className="text-gold-500" size={28} data-id="element-232" />,
  title: 'TOMO 2: El Reset Estratégico',
  subtitle: 'El protocolo de 48 horas para restaurar tu foco desde adentro'
}, {
  icon: <Shield className="text-gold-500" size={28} data-id="element-233" />,
  title: 'TOMO 3: Interrupción de la Parálisis',
  subtitle: 'Cómo arrancar cualquier tarea cuando tu cerebro dice "ahora no"'
}, {
  icon: <Coffee className="text-gold-500" size={28} data-id="element-234" />,
  title: 'TOMO 4: Combustible Cognitivo',
  subtitle: 'Qué comer, qué suplementar y cómo organizar tu energía'
}, {
  icon: <Book className="text-gold-500" size={28} data-id="element-235" />,
  title: 'TOMO 5: Psicología de la Ejecución',
  subtitle: 'Cómo desarmar el ciclo Culpa-Procrastinación'
}, {
  icon: <Layout className="text-gold-500" size={28} data-id="element-236" />,
  title: 'TOMO 6: Diseño de Sistemas Personalizados',
  subtitle: 'Cómo construir el entorno y la rutina adaptada a tu cerebro'
}];
const bonuses = [{
  title: 'Guía Visual de Organización del Espacio',
  value: '$8.990'
}, {
  title: 'Plantilla de Descarga Mental',
  value: '$8.990'
}, {
  title: 'Protocolo S.O.S de Emergencia',
  value: '$8.990'
}];
export const ProductContents = () => {
  return <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-237">
      <div className="max-w-4xl mx-auto" data-id="element-238">
        <h2 className="text-2xl sm:text-4xl font-serif font-bold text-center text-dark mb-10" data-id="element-239">
          ¿Qué incluye exactamente?
        </h2>

        {/* 6 Tomos - compact */}
        <div className="mb-10" data-id="element-240">
          <div className="text-center mb-6" data-id="element-241">
            <span className="inline-block bg-dark text-white font-bold px-5 py-1.5 rounded-full text-xs sm:text-sm tracking-widest" data-id="element-242">
              📦 PRODUCTO BASE — $19.990 ARS
            </span>
          </div>

          <div className="grid sm:grid-cols-2 gap-3" data-id="element-243">
            {tomos.map((tomo, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.05
          }} className="bg-light p-4 rounded-xl border border-gray-200 flex items-start gap-3" data-id="element-244">
                <div className="bg-white w-10 h-10 rounded-lg flex items-center justify-center shrink-0" data-id="element-245">
                  {tomo.icon}
                </div>
                <div data-id="element-246">
                  <h4 className="font-bold text-dark text-sm sm:text-base" data-id="element-247">
                    {tomo.title}
                  </h4>
                  <p className="text-gold-600 font-medium text-xs sm:text-sm mt-0.5 leading-snug" data-id="element-248">
                    {tomo.subtitle}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>

        {/* 3 Bonuses - compact rows */}
        <div className="mb-10" data-id="element-249">
          <h3 className="text-lg sm:text-xl font-serif font-bold text-dark text-center mb-4" data-id="element-250">
            + 3 Regalos Incluidos
          </h3>
          <div className="space-y-2" data-id="element-251">
            {bonuses.map((bonus, idx) => <div key={idx} className="bg-dark rounded-xl p-3 sm:p-4 flex items-center justify-between gap-3" data-id="element-252">
                <div className="flex items-center gap-3" data-id="element-253">
                  <Gift className="text-gold-400 shrink-0" size={20} data-id="element-254" />
                  <span className="text-white font-medium text-sm sm:text-base" data-id="element-255">
                    {bonus.title}
                  </span>
                </div>
                <div className="flex items-center gap-2 shrink-0" data-id="element-256">
                  <span className="text-gray-500 line-through text-xs" data-id="element-257">
                    {bonus.value}
                  </span>
                  <span className="text-gold-400 font-bold text-xs sm:text-sm" data-id="element-258">
                    GRATIS
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        {/* Single CTA */}
        <div className="text-center" data-id="element-259">
          <button onClick={scrollToCheckout} className="group w-full sm:w-auto inline-flex items-center justify-center px-6 sm:px-8 py-4 text-base sm:text-lg font-bold text-white transition-all duration-200 bg-coral-500 rounded-full hover:bg-coral-600 hover:scale-105 shadow-lg shadow-coral-500/30" data-id="element-260">
            👉 ACTIVAR MI RESET
          </button>
          <p className="mt-2 text-xs sm:text-sm text-gray-500 font-medium" data-id="element-261">
            Acceso inmediato · PDF descargable · Precio de lanzamiento
          </p>
        </div>
      </div>
    </section>;
};